import { motion, AnimatePresence } from 'framer-motion';
import { Loader2 } from 'lucide-react';

interface CallReconnectingOverlayProps {
  isReconnecting: boolean;
}

export function CallReconnectingOverlay({ isReconnecting }: CallReconnectingOverlayProps) {
  return (
    <AnimatePresence>
      {isReconnecting && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="absolute top-16 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2 bg-black/60 backdrop-blur-xl text-white/90 px-4 py-2 rounded-full shadow-lg"
        >
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="text-sm font-medium">Reconnecting…</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
